/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Carousel_PreviousInputs */

const da_forside_carousel_previous = /** @type {(inputs: Forside_Carousel_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige citat`)
};

/** @type {(inputs: Forside_Carousel_PreviousInputs) => LocalizedString} */
const en_forside_carousel_previous = da_forside_carousel_previous;

/**

* @param {Forside_Carousel_PreviousInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_previous = /** @type {((inputs?: Forside_Carousel_PreviousInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_PreviousInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_previous(inputs)
	return /** @type {LocalizedString} */ ("Forrige citat")
});